import { MapPin } from "lucide-react";
import { displayDoctorName } from "@/lib/utils";

export function PledgeCard({ pledge, dark = false }) {
  const initials = (pledge.name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
  return (
    <div
      data-testid="pledge-card"
      className={`mx-2 w-72 shrink-0 rounded-2xl border p-5 ${
        dark ? "bg-white/5 border-white/10" : "bg-white border-slate-200 shadow-sm"
      }`}
    >
      <div className="flex items-center gap-3">
        {pledge.photo ? (
          <img
            src={pledge.photo}
            alt={pledge.name}
            className="w-11 h-11 rounded-full object-cover shrink-0 ring-2 ring-[#FF9933]/50"
          />
        ) : (
          <div className="grid place-items-center w-11 h-11 rounded-full bg-gradient-to-br from-[#0056D2] to-[#138808] text-white font-display font-bold text-sm shrink-0">
            {initials || "DR"}
          </div>
        )}
        <div className="min-w-0">
          <p className={`font-display font-bold truncate ${dark ? "text-white" : "text-slate-900"}`}>
            {displayDoctorName(pledge.name)}
          </p>
          <p className={`text-xs truncate ${dark ? "text-[#FF9933]" : "text-[#0056D2]"} font-medium`}>
            {pledge.specialty}
          </p>
        </div>
      </div>
      <div className={`mt-3 flex items-center gap-1.5 text-sm ${dark ? "text-slate-400" : "text-slate-500"}`}>
        <MapPin className="w-4 h-4 shrink-0" />
        <span className="truncate">{pledge.city}, {pledge.state}</span>
      </div>
    </div>
  );
}
